import { USER_MANAGEMENT_URL } from '@cfra-nextgen-frontend/shared/src/config';

export type LoginResponse = {
    success: boolean;
};

export type VerifyResponse = {
    idToken: string;
    accessToken: string;
    refreshToken: string;
    expiresIn: number;
    tokenType: string;
};

export async function loginRequest(email: string): Promise<LoginResponse> {
    const response = await fetch(`${USER_MANAGEMENT_URL}/auth/accessibility/login`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email: email,
        }),
    });
    if (response.status === 404) return {success: false}
    if (!response.ok) throw new Error(`Login failed: ${response.status}`);
    return response.json();
}

export async function verifyRequest(token: string): Promise<VerifyResponse> {
    const response = await fetch(`${USER_MANAGEMENT_URL}/auth/accessibility/verify`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            token: token
        })
    });
    if (!response.ok) throw new Error(`Verification failed: ${response.status}`);
    return response.json();
}
